import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSquare } from '@fortawesome/free-solid-svg-icons'

export default function Loading({ type, descMessage, error }) {
   const squareIconSpin = <FontAwesomeIcon icon={ faSquare } spin color="#00a8d5" size="2x" className="loading-spinner" />
   const squareIconError = <FontAwesomeIcon icon={ faSquare } color="#e4e4e4" size="2x" className="loading-spinner" />
   return (
      <div className="loading-component">
         {
            !error ? (
               <React.Fragment>
                  { squareIconSpin }{ squareIconSpin }{ squareIconSpin }
                  <h4>Loading { type }, please wait. { descMessage && <small>{ descMessage }</small> }</h4>
               </React.Fragment>
            ) : (
               <React.Fragment>
                  { squareIconError }{ squareIconError }{ squareIconError }
                  { <h3><strong>{ error }</strong></h3> }
                  <h4>There has been an error. <a href="https://laticrete.com/en/support-and-downloads/contact-us" rel="noopener noreferrer" target="_blank">Please contact support</a> if this error persists.</h4>
                  {/* <button className="btn btn-primary btn-sm" onClick={ () => window.location.reload() }>Reload</button> */}
               </React.Fragment>
            )
         }
      </div>
   )
}


// WEBPACK FOOTER //
// ./src/components/loading.js